<div class="ctn-dialog">
  <div class="ctn-dialog-header">
    <h4>{{data.title}}</h4>
  </div>

  <div class="ctn-dialog-body">
    <div class="dialog-body-p">
      <div class="columns container-columns" >
        <div class="franco">

          <div class="ctn-franco">
            <div class="ctn-franco-header flex-centered flex-column">
              <div class="title"></div>
              <h4 class="title">
                <span class="chevron">> </span>Franco <span *ngIf="this.contextCustomer.isFrancoUnique">Unique</span>
              </h4>
            </div>
            <div class="ctn-franco-body">

              <div class="ctn-franco-societe ctn-franco-pn">
                <div class="atteinte-franco">

                  <div class="logo logo-pn">
                    <img class="img-pn" src="assets/images/landingPage/logo_pronatura.svg" alt="logo pronatura">
                  </div>
                  <div>Atteinte Franco Pronatura</div>

                  <button class="tile tile-centered btn btn-link disabled-dropdown ctn-progress-bar">
                    <span class="tile-subtitle">{{ 'header.reachedFreeDelivery' | translate}} &nbsp;</span>
                    <span class="progress-bar" [ngClass]="{'progress-bar-orange': (calculatePercentagePn() >= 80 && calculatePercentagePn() < 100), 'progress-bar-green': (calculatePercentagePn() == 100)}">&nbsp;</span>
                  </button>

                  <div>
                    <div>
                      <span>Seuil franco Pronatura : </span> <span>{{contextOrder.price?.seuilFranco | currency:'EUR':'symbol':'1.2-2'}}</span>
                    </div>
                  </div>

                  <div>
                    <div>
                      <span>Mon total Pronatura : </span> <span>{{this.contextFranco?.pronaturaTotalAmount == undefined || this.contextFranco?.pronaturaTotalAmount == null ? 0.00 : this.contextFranco?.pronaturaTotalAmount  | currency:'EUR':'symbol':'1.2-2'}}</span>
                    </div>
                  </div>

                </div>
              </div>

              <div class="ctn-franco-societe ctn-franco-unique">
                <div class="atteinte-franco" *ngIf="this.contextCustomer.isFrancoUnique">

                  <div class="logo logo-oa">
                    <img class="img-oa" src="assets/images/landingPage/logo_organic_alliance.svg" alt="logo organic-alliance">
                  </div>
                  <div>Atteinte Franco Unique</div>

                  <button class="tile tile-centered btn btn-link disabled-dropdown ctn-progress-bar">
                    <span class="tile-subtitle">{{ 'header.reachedFreeDelivery' | translate}} &nbsp;</span>
                    <span class="progress-bar" [ngClass]="{'progress-bar-orange': (calculatePercentage() >= 80 && calculatePercentage() < 100), 'progress-bar-green': (calculatePercentage() == 100)}">&nbsp;</span>
                  </button>

                  <div>
                    <div>
                      <span>Seuil Franco Unique : </span> <span>{{this.contextFranco?.uniqueFrancoMinimalOrderAmount | currency:'EUR':'symbol':'1.2-2'}}</span>
                    </div>
                  </div>

                  <div>
                    <div>
                      <span>Mon total commun : </span> <span>{{this.contextFranco?.totalAmount == undefined || this.contextFranco.totalAmount == null ? 0.00 : this.contextFranco.totalAmount | currency:'EUR':'symbol':'1.2-2'}}</span>
                    </div>
                  </div>
                </div>
              </div>



              <div class="ctn-franco-societe ctn-franco-vtf">
                <div class="atteinte-franco">

                  <div class="logo logo-vtf">
                    <img class="img-vtf" src="assets/images/landingPage/logo_vitafrais.svg" alt="logo vitafrais">
                  </div>
                  <div>Atteinte Franco Vitafrais</div>

                  <button class="tile tile-centered btn btn-link disabled-dropdown ctn-progress-bar">
                    <span class="tile-subtitle">{{ 'header.reachedFreeDelivery' | translate}} &nbsp;</span>
                    <span class="progress-bar" [ngClass]="{'progress-bar-orange': (calculatePercentageVtf() >= 80 && calculatePercentageVtf() < 100), 'progress-bar-green': (calculatePercentageVtf() == 100)}">&nbsp;</span>
                  </button>

                  <div>
                    <div>
                      <span>Seuil franco Vitafrais : </span> <span>350 €</span>
                    </div>
                  </div>

                  <div>
                    <div>
                      <span>Mon total Vitafrais : </span> <span>{{this.contextFranco?.vitafraisTotalAmount == undefined ? 0.00 : this.contextFranco?.vitafraisTotalAmount | currency:'EUR':'symbol':'1.2-2'}}</span>
                    </div>
                  </div>

                </div>
              </div>

            </div>

            <div class="ctn-franco-footer">
              <div class="ctn-btn-vtf">
                <button mat-flat-button class="button-vitafrais" (click)="setCompany(contextService.context.companyCode == 'PRONATURAFRANCE' ? 'VITAFRAIS' : 'PRONATURAFRANCE')">
                  Créer ma commande Vitafrais
                </button>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
  </div>

  <div class="ctn-dialog-footer">
    <div>
      <button mat-flat-button (click)="onNoClick()">Non</button>
      <button mat-button cdkFocusInitial>Oui</button>
    </div>
  </div>
</div>
